'use client'

import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import {styled} from '@styled-system/jsx'
import {radioCard} from '@styled-system/recipes'
import {createStyleContext} from '~/style-context';

const { withProvider, withContext } = createStyleContext(radioCard)

// const Indicator = withContext(RadioGroupPrimitive.Indicator, 'indicator')
// const Icon = withContext(Circle, 'icon')

const Item = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>(({ children, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item ref={ref} {...props}>
      {children}
    </RadioGroupPrimitive.Item>
  )
})
Item.displayName = RadioGroupPrimitive.Item.displayName

export const RadioCard = withProvider(styled(RadioGroupPrimitive.Root), 'root')
export const RadioCardItem = withContext(styled(Item), 'item')
// export const RadioCardIndicator = withProvider(styled(RadioGroupPrimitive.Indicator), 'indicator')
// export const RadioCardIcon = withProvider(styled(Circle), 'icon');
